define('plugin/product/collection/ProductPaginatedCollection',['require','lib/collection/ServerPaginatedCollection','plugin/product/model/ProductModel'],function (require) {

    var Parent = require('lib/collection/ServerPaginatedCollection');
    var ProductModel = require('plugin/product/model/ProductModel');

    return Parent.extend({

        url: '/ext/product/paginated',
        model: ProductModel

    });

});
